import { render, staticRenderFns } from "./saasCommonDetail.vue?vue&type=template&id=1c70698c&scoped=true&"
import script from "./saasCommonDetail.vue?vue&type=script&lang=js&"
export * from "./saasCommonDetail.vue?vue&type=script&lang=js&"
import style0 from "./saasCommonDetail.vue?vue&type=style&index=0&id=1c70698c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70698c",
  null
  
)

export default component.exports